import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import styles from './styles';
import { makeStyles } from '@mui/styles';
import { Box, Fab, Tooltip, Zoom } from '@mui/material';
import classNames from 'classnames';
import { Add, Delete, Edit, Settings } from '@mui/icons-material';
import { Dashboard as DashboardLayout } from '../../layouts';
import { CorporativeGrid } from './components';

const useStyles = makeStyles(styles);

export default function Corporative() {
  //==========================Variables==========================//
  const intl = useIntl();
  const classes = useStyles();
  const [showEditButton, setShowEditButton] = useState(false);
  const [showDeleteButton, setShowDeleteButton] = useState(false);
  const [hovered, setHovered] = useState(false);
  const rootClassNames = classNames(classes.root);

  return (
    <DashboardLayout
      title={intl.formatMessage({ id: 'app.corporate.headTitle' })}
    >
      <div className={rootClassNames}>
        {/* <Typography
          sx={{ color: '#A53693', marginBottom: theme.spacing(2) }}
          variant="h2"
        >
          {intl.formatMessage({ id: 'app.corporate.headTitle' })}
        </Typography> */}
        <div className={classes.content}>
          <CorporativeGrid
            editButton={showEditButton}
            deleteButton={showDeleteButton}
          />
        </div>
      </div>
      <Box
        sx={{
          position: 'fixed',
          bottom: '5vh',
          right: '1vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
          m: '1em',
        }}
        onMouseEnter={() => setHovered(true)}
        onClick={() => setHovered(!hovered)}
        onMouseLeave={() => setHovered(false)}
      >
        <Zoom in={hovered}>
          <Tooltip title="Editar Corporativo">
            <Fab
              onClick={() => {
                setShowEditButton(!showEditButton);
                setShowDeleteButton(false);
              }}
              sx={{
                backgroundColor: '#00AFEF',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#0095D4',
                },
              }}
            >
              <Edit />
            </Fab>
          </Tooltip>
        </Zoom>
        <Zoom in={hovered}>
          <Tooltip title="Eliminar Corporativo">
            <Fab
              onClick={() => {
                setShowDeleteButton(!showDeleteButton);
                setShowEditButton(false);
              }}
              sx={{
                backgroundColor: '#00AFEF',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#0095D4',
                },
              }}
            >
              <Delete />
            </Fab>
          </Tooltip>
        </Zoom>
        <Zoom in={hovered}>
          <Tooltip title="Agregar Corporativo">
            <Fab
              href="/newCorporation"
              sx={{
                backgroundColor: '#00AFEF',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#0095D4',
                },
              }}
            >
              <Add />
            </Fab>
          </Tooltip>
        </Zoom>
        <Tooltip title="Configuración de Corporativo">
          <Fab
            sx={{
              backgroundColor: '#A53693',
              color: 'white',
              width: 80,
              height: 80,
              '&:hover': {
                backgroundColor: '#6A1A5F',
              },
            }}
            aria-label="settings"
            onMouseEnter={() => setHovered(true)}
            onClick={() => setHovered(!hovered)}
          >
            <Settings
              sx={{
                transition: 'transform 0.3s ease-in-out',
                '&:hover': {
                  transform: 'rotate(180deg)',
                },
                transform: hovered ? 'rotate(180deg)' : 'rotate(0deg)',
                width: 40,
                height: 40,
              }}
            />
          </Fab>
        </Tooltip>
      </Box>
    </DashboardLayout>
  );
}
